$ = require 'jquery'
AppcuesNc = require 'network/appcues-nc'
Auth = require 'db/auth'
ClientVersion = require 'debug/client-version'
Controller = require 'controller'
Dialog = require 'views/lib/dialog'
GuidedTourState = require 'view-models/guided-tour-state'
HeaderAddMenuView = require 'views/header/header-add-menu-view'
HeaderChannelPicker = require 'views/header/header-channel-picker'
HeaderMemberMenuView = require 'views/header/header-member-menu-view'
HeaderEnterpriseAdminDashboardMenuView = require 'views/header/header-enterprise-admin-dashboard-menu-view'
HeaderNotificationListView = require 'views/notification/header-notification-list-view'
HeaderAppcuesPopOverComponent = require 'views/header/header-appcues-popover-component'
HeaderGuidedTourView = require 'views/header/header-guided-tour'
HeaderInfoMenuView = require 'views/header/header-info-menu-view'
HeaderInfoHelpMenuView = require 'views/header/header-info-help-menu-view'
MemberState = require 'view-models/member-state'
ModelLoader = require 'db/model-loader'
Notification = require 'models/notification'
PopOver = require 'views/lib/pop-over'
React = require 'react'
getExperiment = require 'lib/experiments/simple-test'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
l = require 'lib/localize'
log = require 'debug/log'
createBoardHelpers = require 'views/board-create/helpers'
track = require 'debug/track'

ClientConfig = require 'debug/client-config'

memberTemplate = require 'views/templates/member'
headerUser = require 'views/templates/header_user'
headerUserAnonymous = require 'views/templates/header_user_anonymous'

module.exports = class HeaderMemberView extends View

  className: 'header-user'

  constructor: ({ currentModel }) ->
    super
    @currentModel = currentModel

  initialize: ->
    if !Auth.isLoggedIn()
      return super
    @listenTo @modelCache, 'add:Notification change:Notification remove:Notification', @renderUnreadNotifications
    @listenTo @model, 'change:showNps change:marketingOptIn change:notificationsCount change:messagesDismissed', @renderUnreadNotifications
    @listenTo @model, 'change:notificationsCount', @updateLastSeen
    @listenTo @model.notificationsSeenState, 'change:lastSeenNotificationGroup', @renderUnreadNotifications
    @listenTo @model, 'change:initials change:avatarHash change:avatarSource change:fullName change:username', @renderAvatar

    @listenTo @modelCache, 'add:Card', @renderTourAtStep(GuidedTourState.CARD_BACK)
    @listenTo @modelCache, 'change:Card:desc', @renderTourAtStep(GuidedTourState.LIST)
    @listenTo @modelCache, 'change:List:name change:List:pos', @renderTourAtStep(GuidedTourState.INVITE)
    @listenTo GuidedTourState, 'change:currentStep change:visible', @render

    @appcuesItems = AppcuesNc.getItems Auth.myId()
    AppcuesNc.on 'appcuesUpdate', ((@appcuesItems) -> @render()), @

    super

  events:
    'click .js-open-inspiration-page': 'viewInspirationPage'
    'click .js-open-header-info-menu': 'viewInfoMenu'
    'click .js-open-header-appcues-menu': 'viewAppcuesMenu'
    'click .js-open-header-notifications-menu': 'viewNotificationsMenu'
    'click .js-open-header-tour-menu': 'viewTourMenu'
    'click .js-open-enterprise-dashboard-menu': 'viewEnterpriseDashboardMenu'
    'click .js-open-header-member-menu': 'viewMemberMenu'
    'mouseenter .js-open-add-menu': 'preloadCreateBoardData'
    'click .js-open-add-menu': 'openAddMenu'
    'click .js-open-channel-picker': 'viewChannelPicker'

  render: ->
    log('render', 'rendering header')
    escapedReturnUrl = Util.escapedReturnUrl()
    if !Auth.isLoggedIn()
      @$el.html(headerUserAnonymous({ escapedReturnUrl }))
      return @

    hasAppcuesNews = !MemberState.getAppcuesOptOut() && @appcuesItems.some((item) -> !item.seen)
    if hasAppcuesNews
      track("Header", "Appcues Menu", "Display Appcues Menu")

    data =
      hasCrown: @model.isFeatureEnabled('crown')
      showChannelPicker:
        (@model.get('channels').allowed.length > 1 ||
        # If we're not on trello.com show the menu to make it easier to switch
        # A/B test configuration
        location.hostname != 'trello.com')
      escapedReturnUrl: escapedReturnUrl
      isEnterpriseAdmin: @model.isEnterpriseAdmin()
      upsellEnabled: !ClientConfig.get('dontUpsell')
      hasAppcuesNews: hasAppcuesNews
      hasGuidedTour: GuidedTourState.isEnabled()

    @$el.html(headerUser(data))

    @renderUnreadNotifications()
    @renderAvatar()
    @renderMemberName()
    @renderTour()

    if getExperiment('onboarding').get('variation') == 'helpOverlay' && \
       !Auth.me().isDismissed('help-overlay') && \
       $(document).width() > 750 # This will cover the page under 750
      @renderInfoMenu(@$('.js-open-header-info-menu'))
    @

  renderMemberName: ->
    @$('.js-member-name').text(
      @model.get('fullName') ? @model.get('username')
    )

  renderAvatar: ->
    log('render', "rendering avatar")

    @$('.member').html(memberTemplate(@model.toJSON()))

    @

  renderUnreadNotifications: ->
    unreadNotifications = @model.unreadNotifications(@modelCache)
    showCount = getExperiment('cardNotifications').get('showCards') \
      && getExperiment('bellCount').get('showCount')
    elem = @$ '.js-open-header-notifications-menu'

    if showCount
      elem
        .toggleClass('display-dot', !unreadNotifications?)
        .toggleClass('display-count', unreadNotifications > 0)
        .attr('data-count', unreadNotifications)

    elem
      .toggleClass('new-notifications', unreadNotifications > 0)
      .toggleClass('other-notifications',
        unreadNotifications == 0 \
          && (@model.shouldShowSurvey() ||
          @model.shouldShowMarketingOptIn() ||
          @model.shouldShowNoticeOfTosChange())
      )

    # Tell the controller to update the title, to reflect the new unread count
    Controller.title()

    @

  renderTourAtStep: (currentStep) ->
    (e) =>
      if !GuidedTourState.isEnabled()
        return @
      track("Header", "Tour", "Open Tour Menu")
      hasDescOnThirdStep = e?.get('desc') && currentStep == GuidedTourState.LIST
      hasMadeProgress = currentStep == GuidedTourState.getStep() + 1
      if hasMadeProgress && (currentStep != GuidedTourState.LIST || hasDescOnThirdStep)
        GuidedTourState.setStep(currentStep)

      Dialog.show
        elem: @$('.js-open-header-tour-menu')
        opacity: 0
        reactElement: React.createElement HeaderGuidedTourView,
          key: "header-guided-tour"
          currentModel: @currentModel
          currentOrganization: Controller.getCurrentOrganization()
          onDismiss: _.bind @dismissTour, @
          onShowTips: _.bind @viewInfoMenuForTour, @
        getViewTitle: -> l(['view title', 'get started'])
        maxWidth: 342
        displayType: 'mod-guided-tour'
        closeOnBlur: false
        hardToClose: true

      @

  dismissTour: ->
    @render()
    GuidedTourState.hide()

  renderTour: (e) ->
    if !GuidedTourState.isEnabled() && !Controller.onCardView()
      Dialog.hide()
    else
      GuidedTourState.show()
      @renderTourAtStep(GuidedTourState.getStep())()

    return

  updateLastSeen: ->
    # They have the notifications dialog open and the count
    # has been updated somewhere so lets also update the last
    # seen count so that the bell count is kept in sync.
    if Dialog.isVisible && \
       Dialog.displayType? && \
       Dialog.displayType.indexOf('mod-notifications') >= 0
      @model.notificationsSeenState.setLastSeen()

  viewAppcuesMenu: (e) ->
    appcuesItem = @appcuesItems.find((item) -> !item.seen) ? @appcuesItems[0]
    if !appcuesItem
      @viewInfoMenu(e)
      return

    track("Header", "Appcues Menu", "Open Appcues Menu")
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-header-appcues-menu')
      reactElement: React.createElement HeaderAppcuesPopOverComponent,
        appcuesItem: appcuesItem
        key: "header-appcues-pop-over-view-#{ appcuesItem.id }"
      getViewTitle: -> l(['view title', 'tips'])
      hidden: -> if !appcuesItem.seen then appcuesItem.markSeen()

    return

  viewTourMenu: (e) ->
    Util.stop(e)

    @renderTourAtStep(GuidedTourState.WELCOME)()

    return

  viewInspirationPage: (e) ->
    track("Header", "Inspiration Page", "Open Information Page")
    Util.stop(e)
    window.open '/inspiration'
    return

  renderInfoMenu: (target) ->
    helpOverlay = getExperiment('onboarding').get('variation') == 'helpOverlay'
    PopOver.toggle
      elem: @$(target)
      view: if helpOverlay then HeaderInfoHelpMenuView else HeaderInfoMenuView
      maxWidth: if helpOverlay then 300 else 360
      onClose: -> if helpOverlay then Auth.me().dismiss('help-overlay')
      options:
        model: @model
        modelCache: @modelCache

  showInfoMenu: (target, e) ->
    if e.altKey
      # trick for viewing already-seen or opted-out-of Appcues announcements
      MemberState.setAppcuesOptOut(false)
      for item in @appcuesItems when item.seen
        item.clearSeen()
      return

    track("Header", "Information Menu", "Open Information Menu")
    Util.stop(e)

    @renderInfoMenu(target)

  viewInfoMenu: (e) ->
    @showInfoMenu('.js-open-header-info-menu', e)

  viewInfoMenuForTour: (e) ->
    @showInfoMenu('.js-open-header-tour-menu', e)

  viewEnterpriseDashboardMenu: (e) ->
    Util.stop(e)

    track("Header", "Enterprise Dashboard Menu", "Open Enterprise Dashboard Menu")

    view = new HeaderEnterpriseAdminDashboardMenuView({ model: Auth.me(), @modelCache })

    PopOver.toggle
      elem: @$('.js-open-enterprise-dashboard-menu')
      view: view

    return

  viewNotificationsMenu: (e) ->
    Util.stop(e)

    if $('.mod-notifications').length
      track("Header", "Notifications Menu", "Close Notifications Menu")
    else
      track("Header", "Notifications Menu", "Open Notifications Menu", @model.unreadNotifications()?.count)

    if @model.shouldShowSurvey()
      @model.trackShowSurvey()

    hideFn = if getExperiment('cardNotifications').get('showCards') \
      then ->
      else _.bind @model.clearAllNotifications, @model

    isShowCards = getExperiment('cardNotifications').get('showCards')

    if Dialog.isVisible
      Dialog.hide()
      return

    Dialog.show
      elem: @$('.js-open-header-notifications-menu')
      hide: hideFn
      maxWidth: if isShowCards then 420 else 450
      displayType: if isShowCards then 'mod-notifications mod-cards' else 'mod-notifications'
      opacity: 0
      closeOnBlur: true
      hardToClose: false
      onScrollInner: -> PopOver.hide()
      reactElement: React.createElement HeaderNotificationListView,
        key: 'header-notifications'
        member: @model,
        markAllRead: _.bind @model.clearAllNotifications, @model
        showSurvey: @model.shouldShowSurvey(),
        showMarketingOptIn: @model.shouldShowMarketingOptIn(),
        showNoticeOfTosChange: @model.shouldShowNoticeOfTosChange(),
        onDismissSurvey: =>
          @model.dismissSurvey()
        submitSurvey: (surveyData) =>
          @model.submitSurvey(surveyData)
        setMarketingOptIn: (optedIn) =>
          @model.setMarketingOptIn(optedIn)
      options:
        model: @model
        modelCache: @modelCache

    return

  preloadCreateBoardData: (e) ->
    createBoardHelpers.preloadData()

  openAddMenu: (e) ->
    Util.stop(e)

    track("Header", "Add Menu", "Open")

    PopOver.toggle
      elem: @$('.js-open-add-menu')
      view: new HeaderAddMenuView({ model: Auth.me(), @modelCache })

    return

  viewMemberMenu: (e) ->
    Util.stop(e)

    track("Header", "User Menu", "Open User Menu")
    view = new HeaderMemberMenuView({ model: Auth.me(), @modelCache })

    PopOver.toggle
      elem: @$('.js-open-header-member-menu')
      view: view

    return

  viewChannelPicker: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-channel-picker')
      view: new HeaderChannelPicker({ model: Auth.me(), @modelCache })

    return



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-member-view.coffee